export enum Endpoint {
  AdminService = 'admin-service',
  OpenIdService = 'openid-service',
}

export type DeploymentConfigBoolean = 'true' | 'false' | boolean;

export type DeploymentConfig = {
  [Endpoint.AdminService]: string;
  [Endpoint.OpenIdService]: string;
  "aws-marketplace": string;
  "directory-client-id": string;
  "google-client-id": string;
  "idaas-webapp": string;
  "nomidio-login-client-id": string;
  "corp-invite-requires-phone": DeploymentConfigBoolean;
}

/**
 * Interpret a config value as a boolean.
 * @param value The config value, which may be optional
 * @returns True if the value is a true boolean or a string form of true
 */
export function fromBoolean(value: DeploymentConfigBoolean | undefined) {
  if (typeof value === "undefined") {
    return undefined;
  }
  return value === true || (typeof value === 'string' && value.trim().toLowerCase() === 'true');
}
